import styled from 'styled-components';

// Reutilizamos el themeConfig de Chatbot.styles.js
export const themeConfig = {
    dark: {
        bgMain: '#343541',
        bgSidebar: '#202123',
        textMain: '#ececf1',
        textSecondary: '#9b9c9f',
        border: '#56586952',
        hover: '#2A2B32',
        shadow: 'rgba(0,0,0,0.5)',
        scrollThumb: '#565869',
        // Colores específicos del modal
        modalBg: '#2c2d31',
        modalBorder: 'rgba(255, 255, 255, 0.08)',
        modalText: '#ececf1',
        modalTextSecondary: '#d1d5db',
        modalTextMuted: '#9ca3af',
        iconColor: '#60a5fa',
        checkmarkColor: '#10b981',
        strongColor: '#60a5fa',
        benefitsBg: 'rgba(255, 255, 255, 0.03)',
        benefitsBorder: 'rgba(255, 255, 255, 0.08)',
        // Botones Premium
        btnPrimaryBg: 'linear-gradient(135deg, #ffffff 0%, #ffffff 100%)',
        btnPrimaryHover: 'linear-gradient(135deg, #fdfdfd 0%, #fdfdfd 100%)',
        btnPrimaryShadow: 'rgba(239, 239, 239, 0.3)',
        btnPrimaryHoverShadow: 'rgba(220, 220, 220, 0.4)',
        textBtnPrimary:'#1f2937',
        // Botón Secondary (Blanco Premium en Dark)
        btnSecondaryBg: '#2c2d31',
        btnSecondaryColor: '#ffffff',
        btnSecondaryHover: '#2c2d31',
        btnSecondaryBorder: '#ffffff',
        // Ghost Button
        btnGhostColor: '#9ca3af',
        btnGhostHover: '#d1d5db',
        btnGhostBg: 'rgba(255, 255, 255, 0.05)'
    },
    light: {
        bgMain: '#ffffff',
        bgSidebar: '#f7f7f8',
        textMain: '#343541',
        textSecondary: '#6e6e80',
        border: '#d9d9e3',
        hover: '#ececf1',
        shadow: 'rgba(0,0,0,0.1)',
        scrollThumb: '#d9d9e3',
        // Colores específicos del modal
        modalBg: '#ffffff',
        modalBorder: '#e5e7eb',
        modalText: '#1f2937',
        modalTextSecondary: '#4b5563',
        modalTextMuted: '#6b7280',
        iconColor: '#3b82f6',
        checkmarkColor: '#059669',
        strongColor: '#2563eb',
        benefitsBg: 'rgba(59, 130, 246, 0.03)',
        benefitsBorder: 'rgba(59, 130, 246, 0.1)',
        // Botones Premium
        btnPrimaryBg: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
        btnPrimaryHover: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
        btnPrimaryShadow: 'rgba(59, 130, 246, 0.25)',
        btnPrimaryHoverShadow: 'rgba(37, 99, 235, 0.35)',
        // Botón Secondary (Gris Premium en Light)
        btnSecondaryBg: '#f8f9fa',
        btnSecondaryColor: '#374151',
        btnSecondaryHover: '#e9ecef',
        btnSecondaryBorder: '#d1d5db',
        // Ghost Button
        btnGhostColor: '#6b7280',
        btnGhostHover: '#374151',
        btnGhostBg: 'rgba(0, 0, 0, 0.03)'
    }
};

export const ModalWrapper = styled.div`
    /* ===================================
       OVERLAY
       =================================== */
    .login-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.75);
        backdrop-filter: blur(4px);
        z-index: 9998;
        animation: fadeIn 0.2s ease;
    }

    /* ===================================
       MODAL CONTAINER
       =================================== */
    .login-modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 16px;
        z-index: 9999;
        width: 90%;
        max-width: 420px;
        max-height: 520px;
        padding: 24px;
        animation: slideUp 0.3s ease;
        overflow-y: auto;
        font-family: 'Work Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        
        background: ${props => props.theme.modalBg};
        color: ${props => props.theme.modalText};
        box-shadow: 0 8px 32px ${props => props.theme.shadow};
        border: 1px solid ${props => props.theme.modalBorder};
    }

    /* ===================================
       HEADER
       =================================== */
    .login-modal-header {
        text-align: center;
        margin-bottom: 16px;
    }

    .login-modal-icon {
        width: 48px;
        height: 48px;
        margin: 0 auto 12px;
        display: block;
        color: ${props => props.theme.iconColor};
        animation: iconPulse 2s ease-in-out infinite;
    }

    .login-modal-header h2 {
        margin: 0;
        font-size: 20px;
        font-weight: 600;
        line-height: 1.2;
        letter-spacing: -0.02em;
        color: ${props => props.theme.modalText};
    }

    /* ===================================
       BODY
       =================================== */
    .login-modal-body {
        margin-bottom: 20px;
    }

    .login-modal-message {
        font-size: 14px;
        line-height: 1.5;
        margin-bottom: 16px;
        text-align: center;
        color: ${props => props.theme.modalTextSecondary};
    }

    .login-modal-message strong {
        font-weight: 700;
        color: ${props => props.theme.strongColor};
    }

    /* ===================================
       BENEFITS GRID (2x2)
       =================================== */
    .login-modal-benefits {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        padding: 14px;
        border-radius: 10px;
        background: ${props => props.theme.benefitsBg};
        border: 1px solid ${props => props.theme.benefitsBorder};
    }

    .benefit-item {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        color: ${props => props.theme.modalTextSecondary};
    }

    .benefit-icon {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        color: ${props => props.theme.checkmarkColor};
    }

    /* ===================================
       ACTIONS - BOTONES PREMIUM
       =================================== */
    .login-modal-actions {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .login-modal-btn {
        width: 100%;
        padding: 12px 20px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        border: none;
        outline: none;
        font-family: inherit;
        letter-spacing: -0.01em;
    }

    /* 🔵 PRIMARY BUTTON - Azul Gradient Premium */
    .login-modal-btn.btn-primary {
        position: relative;
        overflow: hidden;
        background: ${props => props.theme.btnPrimaryBg};
        color: ${props => props.theme.textBtnPrimary};
        box-shadow: 0 4px 12px ${props => props.theme.btnPrimaryShadow};
    }

    .login-modal-btn.btn-primary:hover {
        background: ${props => props.theme.btnPrimaryHover};
        transform: translateY(-2px);
        box-shadow: 0 6px 16px ${props => props.theme.btnPrimaryHoverShadow};
    }

    .login-modal-btn.btn-primary:active {
        transform: translateY(0);
    }

    /* 🔘 SECONDARY BUTTON - Blanco Premium (Dark) / Gris Premium (Light) */
    .login-modal-btn.btn-secondary {
        background: ${props => props.theme.btnSecondaryBg};
        color: ${props => props.theme.btnSecondaryColor};
        border: 1.5px solid ${props => props.theme.btnSecondaryBorder};
        box-shadow: 0 2px 8px ${props => props.theme.shadow};
    }

    .login-modal-btn.btn-secondary:hover {
        background: ${props => props.theme.btnSecondaryHover};
        transform: translateY(-1px);
        box-shadow: 0 4px 12px ${props => props.theme.shadow};
    }

    .login-modal-btn.btn-secondary:active {
        transform: translateY(0);
    }

    /* 👻 GHOST BUTTON - Minimalista */
    .login-modal-btn.btn-ghost {
        background: transparent;
        color: ${props => props.theme.btnGhostColor};
        font-weight: 500;
        font-size: 13px;
        padding: 10px;
    }

    .login-modal-btn.btn-ghost:hover {
        color: ${props => props.theme.btnGhostHover};
        background: ${props => props.theme.btnGhostBg};
    }

    /* ===================================
       ANIMATIONS
       =================================== */
    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translate(-50%, -45%);
        }
        to {
            opacity: 1;
            transform: translate(-50%, -50%);
        }
    }

    @keyframes iconPulse {
        0%, 100% { 
            transform: scale(1);
            opacity: 1;
        }
        50% { 
            transform: scale(1.05);
            opacity: 0.9;
        }
    }

    /* ===================================
       RESPONSIVE
       =================================== */
    @media (max-width: 480px) {
        .login-modal {
            width: 92%;
            padding: 20px;
            max-height: 85vh;
        }

        .login-modal-header h2 {
            font-size: 18px;
        }

        .login-modal-icon {
            width: 40px;
            height: 40px;
            margin-bottom: 10px;
        }

        .login-modal-benefits {
            padding: 12px;
            gap: 8px;
        }

        .benefit-item {
            font-size: 12px;
        }

        .benefit-icon {
            width: 18px;
            height: 18px;
        }

        .login-modal-btn {
            padding: 11px 18px;
            font-size: 13px;
        }
    }

    /* Landscape Mobile */
    @media (max-width: 768px) and (orientation: landscape) {
        .login-modal {
            max-height: 90vh;
            overflow-y: auto;
        }

        .login-modal-benefits {
            grid-template-columns: 1fr;
        }
    }

    /* Scrollbar personalizado */
    .login-modal::-webkit-scrollbar {
        width: 6px;
    }

    .login-modal::-webkit-scrollbar-thumb {
        background-color: ${props => props.theme.scrollThumb};
        border-radius: 10px;
    }

    .login-modal::-webkit-scrollbar-track {
        background: transparent;
    }
`;